<template>
    <el-dialog v-model="isShow" class="modalTemp" dataBackDrop="static" :show-close="false">
        <template #header="{ close, titleId, titleClass }">
            <div class="d-flex justify-content-between px-4 pt-4">
                <h2 slot="header" class="modal-title">Chi tiết sản phẩm</h2>
                <div class="btn btn-sm btn-icon btn-active-color-primary" @click="hideDialog">
                    <span class="svg-icon svg-icon-1">
                        <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
                    </span>
                </div>
            </div>
        </template>
        <el-row :gutter="20">
            <el-col :md="16">
                <el-form label-width="150px" class="demo-ruleForm">
                    <div class="row">
                        <div class="col-sm productDetail">
                            <el-form-item label="Mã sản phẩm:">
                                <label>{{ selectedItem.odooDefaultCode }}</label>
                            </el-form-item>
                            <el-form-item label="Tên sản phẩm:" prop="odooName">
                                <label>{{ selectedItem.odooName }}</label>
                            </el-form-item>

                            <el-form-item label="Đơn giá:" prop="odooListPrice">
                                <label>{{ convertToMoney(selectedItem.odooListPrice) }}</label>
                            </el-form-item>

                            <el-form-item label="Danh mục:" prop="odooPublicCategIds">
                                <el-tag
                                    v-for="item in (selectedItem.odooPublicCategName ? selectedItem.odooPublicCategName.split(',') : [])"
                                    :key="item" style="margin-left: 5px; border-radius: 20px;" type="info"
                                    effect="dark">
                                    {{ item }}
                                </el-tag>
                            </el-form-item>

                            <el-form-item label="Trạng thái:">
                                <el-tag type="success" effect="dark" v-if="selectedItem.odooIsPublished == 1">
                                    Published
                                </el-tag>
                                <el-tag type="warning" effect="dark" v-else>
                                    Unpublished
                                </el-tag>
                            </el-form-item>

                            <el-form-item label="Tình trạng:">
                                <el-tag type="success" v-if="selectedItem.nTinhTrang == 1">Hoạt Động</el-tag>
                                <el-tag type="danger" v-else>Đã xóa</el-tag>
                            </el-form-item>

                        </div>
                    </div>
                </el-form>
            </el-col>
            <el-col :md="8">
                <el-image style="border-radius:5px" :src="srcList[0]" :preview-src-list="srcList" :fit="fit">
                </el-image>
            </el-col>
        </el-row>
        <template #footer>
            <el-button plain type="danger" @click="hideDialog">Thoát</el-button>
        </template>
    </el-dialog>
</template>

<script>
import moment from "moment";
import { convertToMoney } from "@/utils/stringUtils";
import { baseUrl } from "@/utils/global"
import { useStore } from "vuex";
import { Product } from "@/store/enums/StoreEnums";
import { ElMessage } from "element-plus";
export default {

    props: {
        show: {
            type: Boolean,
            description: false
        },
        data: {
            type: Number,
        }
    },

    watch: {
        show: function (newVal, oldVal) {
            try {
                if (newVal) {
                    this.isShow = newVal
                    if (this.data)
                        this.store.dispatch(Product.findProductById, this.data).then((res) => {
                            if (res.code == 200 && res.data)
                                this.selectedItem = res.data;
                            else
                                this.selectedItem = []
                            if (res.code == 200 && res.data && res.data.odooImage1920)
                                this.srcList = [baseUrl + "/product/img/" + res.data.odooImage1920]

                            else
                                this.srcList = [""]
                            //console.log(this.srcList)
                        });
                    else {
                        this.selectedItem = {}
                    }
                }
            }
            catch (ex) {
                console.log(ex);
            }
        }
    },

    data() {
        return {
            fit: "cover",
            srcList: [""],
            selectedItem: {},
            isShow: false,
            store: useStore()
        };
    },
    methods: {

        convertToMoney(num) {
            return convertToMoney(num) + "đ";
        },

        hideDialog() {
            this.isShow = false;
            this.$emit('hideDialog', {})
        },
        momentDate(val) {
            return val ? moment(val).format("DD/MM/YYYY") : ""
        }

    },
    mounted() {

    },
};
</script>

<style>
.modalTemp .modal-body {
    padding-top: 1rem;
    padding-bottom: 1rem;
}

.productDetail .el-form-item--mini.el-form-item {
    margin-bottom: 8px;
}
</style>
